import React, { memo, useEffect, useRef } from "react";

/** Only the stage whose name is exactly "Won" (trimmed, case-insensitive). */
export const isWonStage = (stage) => {
  if (!stage) return false;
  const name = typeof stage === "string" ? stage : stage.columnName;
  if (name == null || typeof name !== "string") return false;
  return name.trim().toLowerCase() === "won";
};

const DEFAULT_DURATION_MS = 4800;

const WinCelebrationInner = ({
  leadName,
  stageName,
  onComplete,
  durationMs = DEFAULT_DURATION_MS,
}) => {
  const onCompleteRef = useRef(onComplete);
  onCompleteRef.current = onComplete;

  useEffect(() => {
    const t = window.setTimeout(() => {
      onCompleteRef.current?.();
    }, durationMs);
    return () => window.clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="win-celebration-overlay"
      role="status"
      aria-live="polite"
      aria-label={`Congratulations, ${leadName || "lead"} moved to ${stageName || "Won"}`}
    >
      <div className="win-celebration-card">
        <div className="win-card-shine" aria-hidden="true" />
        <div className="win-card-glow" aria-hidden="true" />

        <div className="win-icon-badge" aria-hidden="true">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="win-icon-svg"
          >
            <path d="M20 6 9 17l-5-5" />
          </svg>
        </div>

        <p className="win-celebration-kicker">Deal closed</p>
        <h2 className="win-celebration-title">Lead Won</h2>
        <p className="win-celebration-subtitle">
          {leadName ? (
            <>
              <span className="win-celebration-lead">{leadName}</span>
              {stageName ? (
                <>
                  {" "}
                  <span className="win-celebration-muted">landed in</span>{" "}
                  <span className="win-celebration-stage">{stageName}</span>
                </>
              ) : null}
            </>
          ) : (
            <span className="win-celebration-muted">
              Another one in the books.
            </span>
          )}
        </p>
        <div className="win-celebration-dots" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
};

const WinCelebration = memo(WinCelebrationInner, () => true);

export default WinCelebration;
